import { Injectable } from '@angular/core';
import { NewRelicCapacitorPlugin } from '@newrelic/newrelic-capacitor-plugin';
import { environment } from '../../environments/environment';
import { newrelicConfig } from '../../environments/newrelic/newrelic.config';

const PLACEHOLDER_PREFIX = 'REPLACE_ME';

export function isPlaceholderToken(token: string): boolean {
  return token.startsWith(PLACEHOLDER_PREFIX);
}

@Injectable({
  providedIn: 'root',
})
export class ErrorReportingService {
  reportError(error: unknown, context?: Record<string, unknown>): void {
    if (!this.isConfigured()) {
      return;
    }

    const normalizedError = error instanceof Error ? error : new Error(String(error));

    if (environment.iOS || environment.android) {
      NewRelicCapacitorPlugin.recordError({
        name: normalizedError.name,
        message: normalizedError.message,
        stack: normalizedError.stack ?? '',
        isFatal: false,
        attributes: context,
      });

      return;
    }

    (window as any).newrelic?.noticeError(normalizedError, context);
  }


  private isConfigured(): boolean {
    const token = environment.iOS
      ? newrelicConfig.iosAppToken
      : environment.android
        ? newrelicConfig.androidAppToken
        : newrelicConfig.browserLicenseKey;

    return !isPlaceholderToken(token);
  }
}
